<template>
    <b-card :title="$translate('filters')" class="query-filter filter-form" body-class="p-0 mt-3">
        <div>
          <b-row>
                       
            <b-col cols="6 mt-2">
                <label class="mb-3">
                    <strong>{{$translate('month_year')}}<span class="red">*</span></strong>
                </label>
                <b-form-input 
                    type="month" 
                    id="input-month-year" 
                    v-custom-validation="$textRequired()" 
                    v-model="filtersModel.month_year"
                    required 
                    :placeholder="$translate('enter_month_year')" 
                ></b-form-input>
            </b-col>
            <b-col md="6" cols="12" class="mt-3  dd">
              
                <label for="input-type" class="mb-2"><strong>{{ $translate('activity_type') }}<span class="red">*</span></strong></label>
              
                  <multiselect id="input-order_type" :placeholder="$translate('select_activity_type')" 
                v-model="filtersModel.type" 
                :options="orderTypesArray" 
                :searchable="true"
               
                :multiple="true" 
                :preserve-search="true"
                :selectLabel="selectLabel" 
               
                label="name" track-by="id" :close-on-select="true">
                   
                </multiselect>
              
                
            </b-col>
            <b-col md="6" cols="12" class="mt-3  dd">
              
                <label for="input-type" class="mb-2"><strong>{{ $translate('role') }}</strong></label>
              
                  <multiselect id="input-role" :placeholder="$translate('select_role')" 
                v-model="filtersModel.role" 
                :options="roleArray" 
                :searchable="true"
               
                :multiple="true" 
                :preserve-search="true"
                :selectLabel="selectLabel" 
               
                label="name" track-by="id" :close-on-select="true">
                   
                </multiselect>
              
                
            </b-col>
            <b-col md="6" cols="12" class="mt-3  dd">
              
                <label for="input-type" class="mb-2"><strong>{{ $translate('officers') }}</strong></label>
              
                  <multiselect id="input-officers" :placeholder="$translate('select_officers')" 
                v-model="filtersModel.officer" 
                :options="officerArray" 
                :searchable="true"
               
                :multiple="true" 
                :preserve-search="true"
                :selectLabel="selectLabel" 
               
                label="name" track-by="id" :close-on-select="true">
                   
                </multiselect>
              
                
            </b-col>
           
            <b-col md="6" cols="12" class="mt-3  dd">
              
                <label for="input-type" class="mb-2"><strong>{{ $translate('agents') }}</strong></label>
              
                  <multiselect id="input-agents" :placeholder="$translate('select_agents')" 
                v-model="filtersModel.agent" 
                :options="agentArray" 
                :searchable="true"
               
                :multiple="true" 
                :preserve-search="true"
                :selectLabel="selectLabel" 
               
                label="name" track-by="id" :close-on-select="true">
                   
                </multiselect>
              
                
            </b-col>
            <b-col md="6" cols="12" class="mt-3  dd">
              
                <label for="input-type" class="mb-2"><strong>{{ $translate('customer_segment') }}</strong></label>
              
                  <multiselect id="input-customer_segment" :placeholder="$translate('select_customer_segment')" 
                v-model="filtersModel.customer_segment" 
                :options="segmentArray" 
                :searchable="true"
               
                :multiple="true" 
                :preserve-search="true"
                :selectLabel="selectLabel" 
               
                label="name" track-by="id" :close-on-select="true">
                   
                </multiselect>
              
                
            </b-col>
            <b-col md="6" cols="12" class="mt-3  dd">
              
                <label for="input-type" class="mb-2"><strong>{{ $translate('interaction_type') }}</strong></label>
              
                  <multiselect id="input-interaction_type" :placeholder="$translate('select_interaction_type')" 
                v-model="filtersModel.interaction_type" 
                :options="interaction_typeArray" 
                :searchable="true"
               
                :multiple="true" 
                :preserve-search="true"
                :selectLabel="selectLabel" 
               
                label="name" track-by="id" :close-on-select="true">
                   
                </multiselect>
              
                
            </b-col>
           
            
            <b-col md="6" cols="12" class="mt-3  dd">
              
                <label for="input-type" class="mb-2"><strong>{{ $translate('customer_group') }}</strong></label>
              
                  <multiselect id="input-customer_segment" :placeholder="$translate('select_customer_group')" 
                v-model="filtersModel.customer_group" 
                :options="customerGroupArray" 
                :searchable="true"
               
                :multiple="true" 
                :preserve-search="true"
                :selectLabel="selectLabel" 
               
                label="name" track-by="id" :close-on-select="true">
                   
                </multiselect>
              
                
            </b-col>
            <b-col md="6" cols="12" class="mt-3 text-start">
              <label for="input-outstanding_balance" class="mb-3"><strong>{{$translate('target_no_of_activity')}}</strong>
              </label>

              <b-input-group>
                  <b-form-input id="input-outstanding_balance" type="number"
                      v-model="filtersModel.target_no_of_activity"></b-form-input>
                  <template #prepend>
                      <div class="customselect">
                          <select class="form-control" id="select-option-value" v-model="filtersModel.target_no_of_activity_quantityType" value-field="id"
                              text-field="name" block>
                              <option v-for="x in quantities" :key="'customselect:--' + x.id" :value="x.id">
                                  {{ x.name }}
                              </option>
                          </select>
                      </div>
                  </template>
              </b-input-group>
          </b-col>
          <b-col md="6" cols="12" class="mt-3 text-start">
            <label for="input-outstanding_balance" class="mb-3"><strong>{{$translate('target_total_value')}}</strong>
            </label>

            <b-input-group>
                <b-form-input id="input-outstanding_balance" type="number"
                    v-model="filtersModel.target_total_value"></b-form-input>
                <template #prepend>
                    <div class="customselect">
                        <select class="form-control" id="select-option-value" v-model="filtersModel.target_total_value_quantityType" value-field="id"
                            text-field="name" block>
                            <option v-for="x in quantities" :key="'customselect:--' + x.id" :value="x.id">
                                {{ x.name }}
                            </option>
                        </select>
                    </div>
                </template>
            </b-input-group>
        </b-col>
         
        </b-row>
        </div>
    </b-card>
</template>

<script>
// import CustomerTypeAhead from "@/components/CustomerTypeAhead.vue";
import Multiselect from 'vue-multiselect'
export default {
    name: 'targets-filters',
    components: {
        Multiselect
    },
    data(){
        return {
            orderTypesArray: [],
            roleArray :[],
            officerArray : [],
            agentArray : [],
            segmentArray : [],
            interaction_typeArray : [],
            customerGroupArray : [],
            quantities: [
                { id: 1, name: '=' },
                { id: 2, name: '>' },
                { id: 3, name: '<' },
            ],
        }
    },  
    props: ['value'],
    // components:{CustomerTypeAhead },
    mounted() {
        this.orderTypesArray =    this.$store.getters["orderType/activityTypesByPermission"]; 
        this.roleArray = this.roles;
        this.officerArray = this.officers;
        this.agentArray = this.customerAgents;
        this.segmentArray = this.customerSegments;
        this.interaction_typeArray = this.interactionTypes;
        this.customerGroupArray = this.customerGroups;
  },


    computed: {
        filtersModel: {
            // getter
            get() {
                return this.value
            },
            // setter
            set(val) {
                this.$emit('input', val)
            },
        },

        paymentTransactionStatus() {
            return {
                pending: "Pending",
                processed: "Processed",
                cancelled: "Cancelled"
            }
        },

        transaction_type() {
            return {
                incoming: 'Incoming',
                outgoing: 'Outgoing',
            };
        },
        selectLabel() {
            return this.$translate('click_to_select')
        },
        deselectLabel() {
            return this.$translate('click_to_remove')
        },
        selectedLabel() {
            return this.$translate('selected')
        },
        officers() {
        return (this.$store.state.orders.drivers || []).map((x) => ({
            id: x.id,
            name: `${x.first_name} ${x.last_name}`.trim(),
        }));
        },
        roles() {
        return this.$store.state.roles.items;
        },
        categories() {
        return this.$store.state.requestCategory.categories;
        },

        interactionTypes() {
        return this.$store.state.interactionType.interaction_types;
        },
        customerAgents() {
        return this.$store.state.customerAgents.customer_agents.map(user => {
            return {
                ...user,
                name: `${user.first_name} ${user.last_name}`
            };
          });;
        },
        customerSegments() {
            return this.$store.state.customerSegments.customer_segments
        },
        customerGroups() {
            return this.$store.state.customerGroups.customer_groups
        },
 
    },

    watch: {},

    methods: {
    
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tags-wrap {
    display: inline-block;
    height: auto;
}
</style>
